import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { LanguageSwitcher } from '../LanguageSwitcher';
import { useTranslation } from 'react-i18next';
import { resolveColor } from '../../utils/colorUtils';

interface SectionHeaderProps {
  config: any;
  title?: string;
  onBackClick: () => void;
  translations?: Record<string, Record<string, string>>;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ 
  config,
  title,
  onBackClick,
  translations = {}
}) => {
  const { i18n } = useTranslation();

  // Résoudre la couleur de fond du header
  const headerBackgroundColor = resolveColor(config['HFBack-color'], config, config['dark-color']);

  // Résoudre la couleur du texte
  const headerTextColor = resolveColor(config['HFTxt-color'], config, config['light-color']);

  const getTranslatedText = (key: string): string => {
    const translation = translations[key];
    if (!translation) return key;
    return translation[i18n.language] || translation.fr || key;
  };

  return (
    <>
      {/* Extension de la couleur vers le haut */}
      <div 
        className="fixed top-0 left-0 right-0 h-[1000px] -translate-y-full -z-10"
        style={{ backgroundColor: headerBackgroundColor }}
      />
      
      {/* Header principal */}
      <header 
        className="shadow-md header w-full"
        style={{ backgroundColor: headerBackgroundColor }}
      >
        <div className="header-content relative">
          {/* Bouton retour aligné à gauche */}
          <div className="w-10">
            <button 
              onClick={onBackClick}
              className="flex items-center text-white hover:opacity-80 transition-opacity"
              aria-label="Retour à l'accueil"
              style={{ color: headerTextColor }}
            >
              <ChevronLeft size={24} />
              <span className="text-sm font-medium hidden sm:inline ml-2">
                {getTranslatedText('back') || 'Retour'}
              </span>
            </button>
          </div>
          
          {/* Titre centré avec padding minimum */}
          {title && (
            <h1 
              className="absolute left-1/2 -translate-x-1/2 text-2xl font-light text-center truncate px-[10px] max-w-[calc(100%-5rem)]"
              style={{ color: headerTextColor }}
            >
              {title}
            </h1>
          )}
          
          {/* Language switcher aligné à droite */}
          <div className="w-10 flex justify-end">
            <LanguageSwitcher showText={true} textColor={headerTextColor} />
          </div>
        </div>
      </header>
    </>
  );
};